import React from 'react';
import PropTypes from 'prop-types';
import Input from 'components/project/ClerkScreen/shared/Input';
import { observer } from 'mobx-react-lite';

import {
  Container, InputButtonGroup, Label,
} from './Styles';

const OpenItem = observer(({
  inputRef,
  labelText,
  inputTabIndex,
  inputDisabled,
  value,
  onKeyUp,
  onKeyPress,
  onChange,
  onFocus,
  buttonTabIndex,
  buttonDisabled,
  maxLength,
  placeholderText,
  onClick,
  buttonIcon,
  testId,
}) => {
  return (
    <Container>
      <Label>{labelText}</Label>
      <InputButtonGroup>
         <Input
          autoComplete="off"
          disabled={inputDisabled}
          maxLength={maxLength}
          onChange={onChange}
          onFocus={onFocus}
          onKeyPress={onKeyPress}
          onKeyUp={onKeyUp}
          placeholderText={placeholderText}
          ref={inputRef}
          tabIndex={inputTabIndex}
          testId={testId}
          value={value}
        />
        <button
          type="button"
          data-testid="btn-open-item"
          tabIndex={buttonTabIndex}
          disabled={buttonDisabled}
          onClick={onClick}
        >
          <i className={`fa ${buttonIcon}`} aria-hidden="true" />
        </button>
      </InputButtonGroup>
    </Container>
  );
});

OpenItem.propTypes = {
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Input) }),
  ]).isRequired,
  labelText: PropTypes.string,
  defaultValue: PropTypes.any,
  inputTabIndex: PropTypes.number.isRequired,
  inputDisabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.number]),
  onKeyUp: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  buttonTabIndex: PropTypes.number,
  buttonDisabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  buttonIcon: PropTypes.string.isRequired,
  testId: PropTypes.string.isRequired,
};

OpenItem.defaultProps = {
  labelText: '',
  defaultValue: '',
  value: '',
  buttonTabIndex: -1,
  inputDisabled: false,
};

export default OpenItem;
